export const load = () => ({
	title: 'The U.S. DOE Studies Historic Home Energy Efficiency',
	showTitle: true,
});
